module.exports = __webpack_public_path__ + "img/Poorter_hotel-099.d32c8aac.jpg";